import {getContestantsState} from "@/store/States";

const state = getContestantsState()

const getters = {
    cards: (state) => {
        let cards = [];
        for (let i = 1; i <= state.cards.length; i++) {
            let obj = {...state.cards[i-1], id: i, index: i};
            cards.push(obj)
        }
        return cards
    },
    numberOfCards: (state) => state.cards.length,
    favoredContestant: (state) => state.cards.length ? [...state.cards].sort((a, b) => b.probability - a.probability)[0] : {},
    underdogContestant: (state) => state.cards.length ? [...state.cards].sort((a, b) => a.probability - b.probability)[0] : {}
}

const actions = {}

const mutations = {
    resetState(state) {
        Object.assign(state, getContestantsState())
    },
    addCard: function (state, card) {
        state.cards.push(card)
    },
    deleteCard: function (state, i) {
        state.cards.splice(i, 1)
    },
    editCard: function (state, obj) {
        state.cards.splice(obj.i, 1, obj.card)
    },
    reset: function (state) {
        state.cards = []
    },
    setForm(state, contestants) {
        for (let x of contestants)
            state.cards.push(x)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
